import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { OfflineChrome, registerServiceWorker, startOfflineRuntime } from './features/offline';
import { getBackendUrl } from './utils/https';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    {/* Offline chrome lives outside the router so a navigation never unmounts it */}
    <OfflineChrome />
  </React.StrictMode>
);

// Field teams work with no connection: keep the write queue moving and let the
// service worker serve the app shell and the directory they have already seen.
startOfflineRuntime(getBackendUrl());
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
